function Footer() {
  return (
    <footer>
        <div>
          <div className="footer-logo">Magnética</div>
          <p className="footer-tagline">El arte nació para brillar en ti ✦</p>
        </div>

        <div className="footer-links">
          <a href="#servicios">Servicios</a>
          <a href="#agendar">Citas</a>
          <a href="#tienda">Tienda</a>
          <a href="#instagram">Instagram</a>
          <a href="#whatsapp">WhatsApp</a>
        </div>

        <p className="footer-copy">
          © 2026 Magnética Nail Spa · Hecho con ✦
        </p>
      </footer>
  );
}

export default Footer;